import clsx from "clsx";

type ProgressBarProps = {
  color: string;
  completion: number;
  loading?: boolean;
  className?: string;
};

export default function ProgressBar(props: ProgressBarProps): JSX.Element {
  const { completion, className, color } = props;
  const { loading } = props;

  const height = !className || className.indexOf("h-") === -1 ? "h-4" : "";

  return (
    <div
      className={clsx(
        "progress-bar fade-loading relative w-full bg-opacity-50 rounded-lg overflow-hidden",
        className,
        height,
        color,
        { loading }
      )}
      style={{ backgroundColor: color }}
    >
      <div
        className={clsx("completion absolute left-0 top-0 h-full", color)}
        style={{ width: `${completion * 100}%`, backgroundColor: color }}
      ></div>
    </div>
  );
}
